import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    margin-right: 30px;
    margin-bottom : 10px;
    &:last-child {
        margin-right: 0;
    }
`;

export const Value = styled.div`
    display: block;
    ${FONTS.H1};
    span {
        ${FONTS.H2};
    }
    @media (max-width: 1279px) {
        ${FONTS.H2};
        span {
            ${FONTS.H3};
        }
    }
    @media (max-width: 530px) {
        ${FONTS.H3};
        span {
            ${FONTS.H4};
        }
    }
`;

export const Text = styled.div`
    display: block;
    ${FONTS.XXL};
    @media (max-width: 1279px) {
        ${FONTS.L};
    }
    @media (max-width: 530px) {
        ${FONTS.S};
    }
`;
